import styled from 'styled-components';
import { variables } from '../../../assets/styles/variables';

const SfhModalTitle = styled.span`
  font-family: ${variables.family.goldSilverHeaders}, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
`;

export default SfhModalTitle;
